const initState = {
  memberSearchList: [],
  page: 1,
  limit: 10,
  count: 0,
};

const MemberSearchReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_MEMBER_SEARCH":
      return {
        ...state,
        memberSearchList: action.payload.data,
        page: action.payload.page,
        limit: action.payload.limit,
        count: action.payload.count,
      };
    case "RESET_MEMBER_SEARCH_STATE":
      return {
        ...state,
        ...initState,
      };
    default:
      return { ...state };
  }
};

export default MemberSearchReducer;
